<template>
  <b-form-group
    label="Kısa Açıklama"
    label-for="summary"
  >
    <validation-provider
      #default="{ errors }"
      name="Kısa Açıklama"
      rules="required"
    >
      <b-form-textarea
        id="summary"
        v-model="itemData.summary"
        placeholder="Kısa Açıklama"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'SubtitleCategoriesText',
  components: { ValidationProvider, BFormTextarea, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['categories/dataItem']
    },
  },
}
</script>
